import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSimpleAuth } from '../../context/SimpleAuthContext';
import './SimpleLoginPage.css';

const SimpleLoginPage = () => {
  const navigate = useNavigate();
  const { login, user } = useSimpleAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Check if user is already logged in and redirect
  useEffect(() => {
    if (user) {
      console.log('User already logged in, redirecting...');
      if (user.role === 'admin') {
        navigate('/simple-admin', { replace: true });
      } else {
        navigate('/simple-user', { replace: true });
      }
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const result = await login(username, password);
      
      if (result.success) {
        // Redirect based on role
        if (result.user.role === 'admin') {
          navigate('/simple-admin');
        } else {
          navigate('/simple-user');
        }
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const fillCredentials = (type) => {
    if (type === 'user') {
      setUsername('user');
      setPassword('user123');
    } else {
      setUsername('admin');
      setPassword('admin123');
    }
  };

  return (
    <div className="simple-login-container">
      <div className="simple-login-box">
        <h1>Simple Login</h1>
        <p>No backend, no database, just simple demo auth</p>
        
        <form onSubmit={handleSubmit} className="simple-form">
          <div className="form-group">
            <label>Username:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
            />
          </div>

          <div className="form-group">
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>

          {error && <div className="error">{error}</div>}

          <button 
            type="submit" 
            className="login-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="demo-info">
          <h3>Demo Credentials</h3>
          <div className="credential-buttons">
            <button 
              onClick={() => fillCredentials('user')}
              className="demo-btn user"
            >
              Regular User
            </button>
            <button 
              onClick={() => fillCredentials('admin')}
              className="demo-btn admin"
            >
              Admin User
            </button>
          </div>
          <div className="credentials">
            <p><strong>User:</strong> user / user123</p>
            <p><strong>Admin:</strong> admin / admin123</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleLoginPage;
